import useExercisesToDisplay_sets from 'storages/exercisesToDisplay/useExercisesToDisplay_sets';

import useFeatureChecker from '../useFeatureChecker/useFeatureChecker';

/** `legacy_exercises`: classic exercises / sheets store via `useFeatureChecker().useDataStore`. */
export type ExerciseDataSources = 'common_store' | 'legacy_exercises';

// TODO to remove on unify
const useExerciseDataSourceResolver = (source: ExerciseDataSources) => {
  const { useDataStore } = useFeatureChecker();

  switch (source) {
    case 'common_store': {
      return useExercisesToDisplay_sets;
    }
    case 'legacy_exercises':
      return useDataStore;
    default:
      return useDataStore;
  }
};

export default useExerciseDataSourceResolver;
